module.exports = __webpack_public_path__ + "img/urn.5fe0f9cc.svg";